<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Support Our Campaign (Onboarding)</h2>
      <p class="text-sm text-gray-500">Guides visitors toward creating their own supporting campaign.</p>
    </header>

    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Eyebrow</label>
        <input
          v-model="content.eyebrow"
          type="text"
          maxlength="120"
          class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        >
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Headline</label>
        <input
          v-model="content.headline"
          type="text"
          maxlength="250"
          class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        >
      </div>
    </div>

    <TemplateRichTextInput
      v-model="content.intro"
      label="Intro"
      :max-length="3000"
    />

    <div>
      <label class="mb-2 block text-sm font-medium text-gray-700">Steps</label>
      <TemplateRepeatableList
        v-model="content.steps"
        :max-items="6"
        :new-item="newStep"
        item-noun="step"
      >
        <template #item="{ item, index }">
          <div class="space-y-2">
            <input
              v-model="item.title"
              type="text"
              maxlength="120"
              :placeholder="`Step ${index + 1} title`"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            >
            <textarea
              v-model="item.body"
              rows="2"
              maxlength="1000"
              placeholder="Step body"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            />
            <TemplateImageInput
              v-model="item.image"
              :upload-url="uploadUrl"
              subfolder="support"
              label=""
              help-text="Illustration shown next to this step."
            />
          </div>
        </template>
      </TemplateRepeatableList>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">CTA label</label>
        <input
          v-model="content.cta_label"
          type="text"
          maxlength="120"
          class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        >
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">CTA link</label>
        <input
          v-model="content.cta_link"
          type="text"
          maxlength="500"
          class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
        >
      </div>
    </div>
  </section>
</template>

<script>
import TemplateImageInput from '../TemplateImageInput.vue';
import TemplateRepeatableList from '../TemplateRepeatableList.vue';
import TemplateRichTextInput from '../TemplateRichTextInput.vue';

export default {
  name: 'SupportOnboardingSectionEditor',
  components: { TemplateImageInput, TemplateRepeatableList, TemplateRichTextInput },
  props: {
    content: { type: Object, required: true },
    uploadUrl: { type: String, required: true },
  },
  methods: {
    newStep() {
      return { title: '', body: '', image: '' };
    },
  },
};
</script>
